import { useState, useEffect, useReducer, useRef } from 'react';
import axios from 'axios';

import { getReducer } from '../../../utils';

import Banner from './compoments/Banner';
import Brochure from './compoments/Brochure';
import Statistics from './compoments/Statistics';
import OurServices from './compoments/OurServices';
import OurPartners from './compoments/OurPartners';
import NewsEvents from './compoments/NewsEvents';
import Feedback from './compoments/Feedback';
import LoadingBox from '../../compoment/LoadingBox';
import MessageBox from '../../compoment/MessageBox';
import EnrollmentForm from '../enrollment/EnrollmentForm';
import ModalEnrollment from '../enrollment/ModalEnrollment';
import useIsDevice from '../../../format/useIsDevice';

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return { ...state, loading: true };
    case 'FETCH_SUCCESS_BANNER':
      return { ...state, banners: action.payload, loading: false };
    case 'FETCH_SUCCESS_POST':
      return { ...state, news: action.payload, loading: false };
    case 'FETCH_FAIL':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const Main = () => {
  const [modalShow, setModalShow] = useState(false);
  const hasFetchedRef = useRef(false);
  const isTablet = useIsDevice(576, 991);
  const limitPost = isTablet ? 2 : 3;

  const [{ loading, error, banners, news }, dispatch] = useReducer(
    getReducer(reducer),
    {
      news: [],
      banners: [],
      loading: true,
      error: '',
    }
  );

  useEffect(() => {
    const fetchData = async () => {
      if (hasFetchedRef.current) return;
      hasFetchedRef.current = true;

      dispatch({ type: 'FETCH_REQUEST' });
      try {
        const resultPageSection = await axios.get('/page-section/public/shows');
        const filterBanner = resultPageSection.data.data.filter(
          (item) => item.sectionType === 'banner'
        );
        const bannerContents = filterBanner
          .map((banner) => banner.content)
          .flat();
        dispatch({ type: 'FETCH_SUCCESS_BANNER', payload: bannerContents });

        const resultPost = await axios.get('/post/public/shows');
        const newPost1 = resultPost.data.data.posts
          .filter((item) =>
            item.topics.find(
              (topicItem) => topicItem.slug === 'noi-bo-thanh-dong'
            )
          )
          .sort((a, b) => new Date(b.published_at) - new Date(a.published_at))
          .slice(0, 3);
        const newPost2 = resultPost.data.data.posts
          .filter((item) =>
            item.topics.find((topicItem) => topicItem.slug === 'chuyen-nganh')
          )
          .sort((a, b) => new Date(b.published_at) - new Date(a.published_at))
          .slice(0, 3);
        const combinedData = [
          {
            title: 'Nội bộ Thành Đồng',
            slug: 'noi-bo-thanh-dong',
            data: newPost1,
          },
          {
            title: 'Chuyên ngành',
            slug: 'chuyen-nganh',
            data: newPost2,
          },
        ];

        dispatch({ type: 'FETCH_SUCCESS_POST', payload: combinedData });
      } catch (err) {
        dispatch({ type: 'FETCH_FAIL', payload: err.message });
      }
    };
    fetchData();

    const timer = setTimeout(() => {
      setModalShow(true);
    }, 10000);

    return () => clearTimeout(timer);
  }, [limitPost]);

  return loading ? (
    <LoadingBox />
  ) : error ? (
    <MessageBox variant="danger">{error}</MessageBox>
  ) : (
    <div>
      <Banner banners={banners} />
      <Brochure />
      <Statistics />
      <OurServices />
      <NewsEvents
        news={news.map((item) => ({
          ...item,
          data: item.data.slice(0, limitPost),
        }))}
      />
      <Feedback />
      <OurPartners />
      <EnrollmentForm />
      <ModalEnrollment show={modalShow} onHide={() => setModalShow(false)} />
    </div>
  );
};

export default Main;
